<template>
  <div>
    <router-view />
    <v-overlay
      :model-value="isAppShellLoading"
      persistent
      class="align-center justify-center"
      content-class="app-shell-overlay"
    >
      <div class="app-shell-loader">
        <v-progress-circular indeterminate size="64" color="primary" />
        <div class="text-body-1 text-white mt-4">
          {{ appShellLoadingMessage }}
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { Hub } from 'aws-amplify/utils'
import { useSnackbarStore } from '@/store/snackbar'
import { useAppShell } from '@/composables/appShell'
import { clearAuthSession } from '@/utils/session'

const router = useRouter()
const snackbarStore = useSnackbarStore()
const appShell = useAppShell()
const { isAppShellLoading, appShellLoadingMessage } = appShell

let unsubscribeHub: (() => void) | null = null

onMounted(() => {
  unsubscribeHub = Hub.listen('auth', ({ payload }) => {
    // Exibe erro se o SSO falhar no lado do Cognito
    if (payload.event === 'signInWithRedirect_failure') {
      const errMsg = (payload.data as any)?.error || 'Erro desconhecido'
      snackbarStore.showSnackbar({
        text: `Falha no login SSO: ${errMsg}`,
        color: 'error',
        timeout: 7000
      })
      clearAuthSession()
      appShell.setLoading(false)
      router.push('/login')
    }
  })
})

onUnmounted(() => {
  unsubscribeHub?.()
})
</script>

<style scoped>
.app-shell-loader {
  min-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 40px;
  border-radius: 20px;
  background: rgba(13, 27, 42, 0.88);
  backdrop-filter: blur(8px);
}
</style>
